/* eslint-disable */
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Row, Col, Form, AutoComplete, Input, Select, message, Spin, Drawer, Space, Modal, Table, Typography } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import { unstable_batchedUpdates as batchedUpdates } from 'react-dom';
import "moment-timezone";
import { Scrollbars } from 'react-custom-scrollbars';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import DetailsPage from './DetailsPage/Detailspage';
import LeadFields from './DetailsPage/LeadDetailsFields'
import RelatedTab from './DetailsPage/RelatedTab'
import LeadRightData from './DetailsPage/LeadRightData'
import LeadStatusBar from './DetailsPage/LeadStatusBar'
import AddTaskPage from './AddTask'
import { UploadUserTag } from './GlobalComponents/UserCardCmnts'
import { setEditCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { AddUser } from '../style';
import { hunterioLeadDetails } from '../../../Api/Services/CompanyApiService'
import {
    getAllCustomGroupByEntity, findAllCustomOptionsByDropdown,
    findAllCustomFieldsByGroupAndEntity,
} from '../../../Api/Services/CustomeUIApiService';
import { getStateData, getCityData, getAllUsersData, getCountryData } from '../../../Api/Services/CommonApiService'
import { LeadDetailData, FetchAllLead, LeadUpdate, LeadSave } from '../../../Api/Services/LeadApiServices';
import { FetchAllAccount } from '../../../Api/Services/AccountApiService';
import { useNavigationDecrypted, useExcryptedNavigation, convertCurrency, ExchangeCurrency } from '../Filters/FilterConditions';
import { Main, BasicFormWrapper, VerticalFormStyleWrap } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import Heading from '../../../components/heading/heading';
import ConvertPopup from "../Popup/LEMassPopup"
import NotesPopup from '../Popup/NotesPopup'
import CallLogPopup from '../Popup/CallLogPopup'
import AllCancelPopup from '../Popup/AllCancelPopup';
import UpdateConnectionPopup from '../Popup/UpdateConnectionPopup';
import DefaultMessagePopup from '../Popup/DefaultMessagePopup'
import Approvaldialog from '../Popup/Approvaldialog'
import ComposeMail from '../Email/Compose';
import MeetingLiPopup from '../Popup/MeetingLiPopup'
import MergePage from '../Popup/MergePage'
import SharePopup from '../Popup/SharePopup'
import AddtoCampaignPopup from '../Popup/AddtoCampaignPopup'
import AddtoOutreachPopup from '../Popup/AddtoOutreachPopup'
import { CalendarIcon, CloneIcon, EditIcon, ShareIcon, CancelIcon, QUSOINIcon, DeleteIcon, SaveIcon, ChangeOwnerIcon, MergeIcon, ConvertIcon, EmailIcon, TaskIcon, NotesIcon, CallLogIcon, CampaignIcon, EmailseqQueueIcon } from '../../../components/Icons/Icons';
import CommonFormFields from '../CustomizeUi/DynamicFieldGroup';

const { Option } = Select;

const LEAD_SPECIAL_FIELDS = {
    // ── Lead Owner (user card dropdown with profile pic) ───────────────────────
    leadOwner: ({ users }) => (
        <Select
            style={{ width: '100%' }}
            placeholder="Select Lead Owner"
            showSearch
            optionLabelProp="label"
            filterOption={(input, option) => {
                const el = option.children.props.children[1].props.children[0];
                if (el?.props?.children) {
                    return String(el.props.children).toLowerCase().includes(input.toLowerCase());
                }
                return false;
            }}
        >
            {users}
        </Select>
    ),
    // ── Account Name (AutoComplete + cascades industry/rating/revenue/website) ──
    accountName: ({ form, account, setDataDisables, setRelatedLead }) => (
        <AutoComplete
            options={account.map(acc => ({
                value: acc.value,
                key: acc.key,
                data: acc.data,
                label: (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>{acc.value}</span>
                        <span>({acc.data.status})</span>
                    </div>
                ),
            }))}
            onSelect={(value, option) => {
                form.setFieldsValue({
                    accountName: value,
                    industry: option.data.industry,
                    rating: option.data.rating,
                    noofemployees: option.data.employee,
                    annualrevenue: option.data.revenue,
                    website: option.data.website,
                });
                setRelatedLead(option.data.leadId);
                setDataDisables({
                    isDisable: option.data.status === "Qualified",
                    allow: option.data.status === "Qualified",
                    id: option.data.accountID,
                    profile: option.data.accountProfile,
                });
            }}
            onChange={(inputValue) => {
                const match = account.find(acc => acc.value === inputValue);
                if (!match) {
                    form.setFieldsValue({
                        industry: undefined, rating: undefined,
                        noofemployees: undefined, annualrevenue: undefined, website: undefined,
                    });
                    setDataDisables({ isDisable: false, allow: false, id: null, profile: null });
                    setRelatedLead(null);
                }
            }}
            style={{ width: '100%' }}
            placeholder="Type or select an account"
            filterOption={(inputValue, option) =>
                option.value.toLowerCase().includes(inputValue.toLowerCase())
            }
        >
            <Input />
        </AutoComplete>
    ),
    // ─ Country → triggers state load ─────────────────────────────────────────
    country: ({ allCountry, country, handleCountryChange }) => (
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="Select Country"
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={handleCountryChange}
            value={country}
        >
            {allCountry?.map(opt => (
                <Option key={opt.countryId} value={opt.country}>{opt.country}</Option>
            ))}
        </Select>
    ),
    // ── State → depends on country ─────────────────────────────────────────────
    state: ({ allState, state, handleStateChange }) => (
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="Select State"
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={handleStateChange}
            value={state}
        >
            {allState?.map(opt => (
                <Option key={opt.stateId} value={opt.state}>{opt.state}</Option>
            ))}
        </Select>
    ),
    // ── City → depends on state ────────────────────────────────────────────────
    city: ({ allCity, city, handleCityChange }) => (
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="Select City"
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={handleCityChange}
            value={city}
        >
            {allCity?.map(opt => (
                <Option key={opt.cityId} value={opt.city}>{opt.city}</Option>
            ))}
        </Select>
    ),
};
const DEFAULT_DROPDOWN_FIELDS = ["leadOwner", "accountName", "country", "state", "city"];
const excludedFields = ["title", "firstName", "lastName", "designation", "leadOwner", "accountName", "industry", "rating", "nomOfEmployees", "annualRevenue", "website"];
const excludedType = ["FileUpload", "MultiFileUpload"];
const DEFAULT_DROPDOWN_DISPLAY_FIELDS = {
    "title": "titleName",
    "leadStatusId": "leadStatus",
    "leadSourceId": "leadSource",
    "seniorityLevelId": "seniorityLevel",
    "industry": "industryName",
};

function AddNew({ UrlId, FromPage, setCratePage, GetAll, ShortCut }) {
    const loadingRef = useRef(false);
    const prevValues = useRef({ UrlId: "", FromPage: "" });
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const urlPathname = window.location.pathname;
    const urlSearch = window.location.search;
    const combinedUrl = urlPathname + urlSearch;
    const { emailapiValues, emailactiontype } = useSelector((state) => state.EmailData);
    const dispatch = useDispatch();
    const history = useHistory();
    const [form] = Form.useForm();
    const localData = useSelector((state) => state.localRedux);
    const ENTITY_ID = localData?.allEntity?.find((item) => item.entityKey === 'leads')?.customEntityId
    const Role = localData.role;
    const [editField, setEditField] = useState(false);
    const [doubleClick, setDoubleClick] = useState(false);
    const [deleteClick, setDelteClick] = useState(false);
    const permission = localData.permissions;
    const ProfileData = localData.profile;
    const profile = ProfileData;
    const companyProfile = localData.company;
    const defaultCurrency = localData.currency
    function extractTimeZoneName(tzString) {
        const parts = tzString.split(" ");
        return parts[1];
    }
    const tzString = profile?.timeZone || "(GMT+0:00) UTC";
    const tz = extractTimeZoneName(tzString);
    const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm");
    const currentDate = new Date(currentrealTime);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    const hours = String(currentDate.getHours()).padStart(2, '0');
    const minutes = String(currentDate.getMinutes()).padStart(2, '0');
    const formattedTime = `${hours}:${minutes}`;
    const [optionsMap, setOptionsMap] = useState({});
    const [trigger, setTrigger] = useState();
    const [relatedLead, setRelatedLead] = useState();
    const [edit, setEdit] = useState(false);
    const [approveOpen, setApproveOpen] = useState(false);
    const [leadId, setLeadId] = useState();
    const [displayData, setDisplayData] = useState();
    const [arrayDisplayData, setArrayDisplayData] = useState();
    const [country, setCountry] = useState();
    const [allCountry, setAllCountry] = useState([]);
    const [state, setState] = useState();
    const [allState, setAllState] = useState([]);
    const [city, setCity] = useState();
    const [allCity, setAllCity] = useState([]);
    const [uiReady, setUiReady] = useState(false);
    const [users, setUsers] = useState([]);
    const [popup, setPopup] = useState(false);
    const [values, setValues] = useState();
    const [campaignPopup, setCampaignPopup] = useState(false);
    const [outreachPopup, setOutreachPopup] = useState(false);
    const [popupType, setPopupType] = useState();
    const [action, setAction] = useState();
    const [assignOwner, setAssignOwner] = useState();
    const [notePopup, setNotePopup] = useState(false);
    const [callLogPopup, setCallLogPopup] = useState(false);
    const [NacTrigger, setNaCTrigger] = useState();
    const [page, setPage] = useState();
    const [mailOpen, setMailOpen] = useState(false);
    const [taskProp, setTaskProp] = useState();
    const [taskPage] = useState("AddPage");
    const [dataDisables, setDataDisables] = useState({ isDisable: false, allow: false, id: null, profile: null });
    const [drawerPage, setDrawerPage] = useState();
    const [pages] = useState("Meeting");
    const [dataPermissions, setDataPermissions] = useState();
    const [createPageTask, setCreatePageTask] = useState();
    const [popupMessage, setPopupMessage] = useState(false);
    const [meetingOpen, setMeetingOpen] = useState(false);
    const [account, setAccount] = useState([]);
    const [sharePopup, setSharePopup] = useState(false);
    const [mergeOpen, setMergeOpen] = useState(false);
    const [approveCondition, setApproveCondition] = useState(false);
    const [meetingAttendees, setMeetingAttendees] = useState([]);
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false);
    const [errorData, setErrorData] = useState([]);
    const [isModalVisible1, setIsModalVisible1] = useState(false);
    const [permissions] = useState(permission.entity);
    const [allFieldStructure, setAllFieldStructure] = useState([]);
    const [customGroups, setCustomGroups] = useState([]);
    const [customFields, setCustomFields] = useState();
    const [seniority, setSeniority] = useState([])
    const [leadStatusData, setLeadStatusData] = useState([])
    const ConvertRate = defaultCurrency?.exchangeRate;
    const CurencyDecimalPlace = defaultCurrency?.decimalOfCurrency;
    const [images, setImages] = useState({});
    const [deleteOptions, setDeleteOptions] = useState({});
    const [fileLists, setFileLists] = useState({});
    const setImage = (fieldKey, url) =>
        setImages(prev => ({ ...prev, [fieldKey]: url }));
    const setDeleteOption = (fieldKey, bool) =>
        setDeleteOptions(prev => ({ ...prev, [fieldKey]: bool }));
    const setFileList = (fieldKey, list) =>
        setFileLists(prev => ({ ...prev, [fieldKey]: list }));
    const scroolup = () => {
        const currentPosition = window.scrollY;
        if (currentPosition > 0) {
            const scrollStep = Math.max(1, Math.ceil(currentPosition / 20));
            window.scrollTo(0, currentPosition - scrollStep);
            requestAnimationFrame(scroolup);
        }
    };
    function formatDate(value, profile) {
        if (!value) return "";
        const format = profile?.dateFormate && profile?.dateFormate !== "" ? profile?.dateFormate : "YYYY-MM-DD";
        return moment(value).format(format);
    }
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => { const match = tzStr.match(/\)\s*([A-Za-z/_]+)/); return match ? match[1] : ""; };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) { console.warn("Invalid timezone provided"); return ""; }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone);
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        return converted.format(dateFormat);
    }
    const [states, setStates] = useState({ selectedRows: [], selectedRowKeys: [] });
    const PageCancel = () => { history.push('/Home/leads'); };
    const canCreate = (rolePermissions, actionRoleId) => {
        if (!Array.isArray(rolePermissions)) return false;
        return rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
    };
    const canShare = (dataPermissions, action) => {
        if (!dataPermissions) return false;
        return dataPermissions.split(",").map(p => p.trim().toLowerCase()).includes(action.toLowerCase());
    };
    const hasRoleDeletePermission = (rolePermissions, actionRoleId) => {
        if (!Array.isArray(rolePermissions)) return false;
        return rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
    };
    const canUpdateDelete = (rolePermissions, dataPermissions, action, actionRoleId) => {
        if (!Array.isArray(rolePermissions) || !dataPermissions) return false;
        const norm = dataPermissions.split(",").map(p => p.trim().toLowerCase());
        return (rolePermissions.includes(actionRoleId) || rolePermissions.includes("*")) && norm.includes(action.toLowerCase());
    };
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    const successMessage = (titles, data, type) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    {type === "Approve" ? <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} /> : <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />}
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => {
                modal.destroy();
                if (type === "Approve") { setTimeout(() => { history.push('/Home/leads'); }, 1000); }
            }
        });
    };
    const getLeadStatus = async () => {
        try {
            const statusDropdown = allFieldStructure.find((item) => item.fieldKey === "leadStatusId")
            const data = await findAllCustomOptionsByDropdown(statusDropdown.dropdownId)
            const OriginalOrder = data.sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
            setLeadStatusData(OriginalOrder)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getSeniorityLevel = async () => {
        try {
            const statusDropdown = allFieldStructure.find((item) => item.fieldKey === "seniorityLevelId")
            const data = await findAllCustomOptionsByDropdown(statusDropdown.dropdownId)
            const OriginalOrder = data.sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
            setSeniority(OriginalOrder)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getCity = async (Address, isoCode) => {
        try {
            const response = await getCityData(isoCode);
            setAllCity(response);
            if (Address.city) { setCity(Address.city) } else { setCity(null); form.setFieldsValue({ city: null }) }
        } catch (error) { message.error(error); }
    };
    const getState = async (Address, option) => {
        try {
            const response = await getStateData(option);
            setAllState(response);
            if (Address.state) {
                setState(Address.state);
                const stateinfo = response.find(s => s.state === Address.state);
                if (stateinfo) { getCity(Address, stateinfo.stateId); }
            } else { setState(null); form.setFieldsValue({ state: null, city: null }) }
        } catch (error) { message.error(error); }
    };
    const onnavigate = () => { history.push("/Home/email-config"); };
    async function fetchLeadAndAccount() {
        try {
            const [leads, accounts] = await Promise.all([FetchAllLead(), FetchAllAccount()]);
            return { leads, accounts };
        } catch (error) { message.error(error); throw error; }
    }
    function getLatestLeads(leads) {
        const result = leads.reduce((acc, lead) => {
            const key = lead.accountName;
            if (!acc[key]) { acc[key] = lead; return acc; }
            const currentDT = (lead.modified_at || "").split("-").join("") + (lead.modified_time || "").split(":").join("");
            const existingDT = (acc[key].modified_at || "").split("-").join("") + (acc[key].modified_time || "").split(":").join("");
            if (currentDT > existingDT) { acc[key] = lead; }
            return acc;
        }, {});
        return Object.values(result);
    }
    async function AccountApi() {
        try {
            const { leads, accounts } = await fetchLeadAndAccount();
            const latestLeads = getLatestLeads(leads);
            const leadAccounts = latestLeads.map(item => ({
                value: item.accountName, key: item.accountName,
                data: { status: "Not Qualified", accountID: null, accountProfile: null, industry: item.industry, rating: item.rating, employee: item.nomOfEmployees, revenue: item.annualRevenue, website: item.website, leadId: item.leads_id }
            }));
            const apiAccounts = accounts.map(item => ({
                value: item.accountName, key: item.accountName,
                data: { status: "Qualified", accountID: item.account_id, accountProfile: item.accountProfile, industry: item.industry, rating: item.rating, employee: item.nomOfEmployees, revenue: item.annualRevenue, website: item.website, leadId: null }
            }));
            setAccount(Array.from(new Map([...leadAccounts, ...apiAccounts].map(item => [item.value, item])).values()));
        } catch (error) { message.error(error); }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData();
            const options = data.filter(item => item.department === "Sales").map((option, i) => (
                <Option value={option.userId}
                    label={(
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className='Div_flex2'>
                                <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                    {option.profilePic ? <img src={option.profilePic} alt="profile" /> : <span className="image_icon UserIcon">{option.firstName.slice(0, 1).toUpperCase()}</span>}
                                    <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                                </div>
                            </div>
                        </div>
                    )} key={i}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>{option.profilePic ? <img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} /> : <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>{option.firstName.slice(0, 1).toUpperCase()}</span>}</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>
            ));
            setUsers(options);
        } catch (error) { message.error(error); }
    }
    const getCountry = async () => {
        try {
            const response = await getCountryData();
            setAllCountry(response);
            if (displayData?.country) {
                const countryInfo = response.find(c => c.country === displayData.country);
                if (countryInfo) { getState(displayData, countryInfo.countryId); }
            } else {
                form.setFieldsValue({
                    country: null, state: null, city: null
                })
            }
        } catch (error) { message.error(error); }
    };
    // ─── Custom Groups & Fields ────────────────────────────────────────────────
    const fetchCustomGroupsAndFields = async () => {
        try {
            const groups = await getAllCustomGroupByEntity(ENTITY_ID);
            const sorted = [...(groups || [])].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
            const results = await Promise.all(
                sorted.map(group => findAllCustomFieldsByGroupAndEntity(ENTITY_ID, group.customFieldGroupId))
            );
            const fieldsMap = {};
            sorted.forEach((group, index) => {
                fieldsMap[group.customFieldGroupId] = [...(results[index] || [])].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
            });
            const allFields = Object.values(fieldsMap).flat();
            const structure = allFields.map((field) => ({
                entityId: field.entityId,
                fieldId: field.fieldId,
                fieldKey: field.fieldKey,
                fieldType: field.fieldType,
                fieldLabel: field.fieldLabel,
                customFieldType: field.customFieldType,
                dropdownId: field.dropdownId,
                dropdownType: field.dropdownType,
                value: field.fieldType === 'MultiFileUpload' ? [] :
                    field.fieldType === "CheckBox" ? false : null,
            }));
            batchedUpdates(() => {
                setCustomGroups(sorted);
                setCustomFields(fieldsMap);
                setAllFieldStructure(structure);
            });
        } catch {
            message.error("Failed to load custom fields");
        }
    };
    // Preprocess values for form rendering
    async function preprocessFormValues(value, allFieldStructure) {
        const formattedValue = { ...value };
        formattedValue.customFieldValues = await Promise.all(
            (formattedValue.customFieldValues || []).map(async cf => {
                const fieldDef = allFieldStructure.find(f => f.fieldId === cf.fieldId);
                if (!fieldDef) return cf;
                let newValue;
                switch (fieldDef.fieldType) {
                    case "Multi-Dropdown":
                        newValue = cf.value ? cf.value.split(",").map(id => Number(id)) : [];
                        break;
                    case "Dropdown":
                        newValue = cf.value !== undefined && cf.value !== null ? Number(cf.value) : null;
                        break;
                    case "Number":
                    case "Percentage":
                        newValue = cf.value ? Number(cf.value) : null;
                        break;
                    case "Currency": {
                        const convertedCost = cf.value ? await ExchangeCurrency(Number(cf.value), ConvertRate) : null;
                        newValue = convertedCost ? Number(convertedCost?.toFixed(CurencyDecimalPlace)) : null;
                        break;
                    }
                    case "Date":
                        newValue = cf.value ? moment(cf.value) : null;
                        break;
                    case "CheckBox":
                        newValue = cf.value === "1" || cf.value === 1 || cf.value === true || cf.value === "true";
                        break;
                    default:
                        newValue = cf.value;
                        break;
                }
                return { ...cf, value: newValue };
            })
        );
        await Promise.all(
            allFieldStructure
                .filter(f => f.customFieldType === "Default")
                .map(async item => {
                    let val = formattedValue[item.fieldKey] ?? null;
                    switch (item.fieldType) {
                        case "Multi-Dropdown":
                            val = val ? val.split(",").map(id => Number(id)) : [];
                            break;
                        case 'MultiFileUpload':
                            val = val || [];
                            break;
                        case "Dropdown": {
                            if (DEFAULT_DROPDOWN_FIELDS.includes(item.fieldKey)) {
                                val = normalizeValue(val)
                            } else {
                                val = val !== undefined && val !== null ? Number(val) : null;
                            }
                            break;
                        }
                        case "Number":
                        case "Percentage":
                            val = val !== undefined && val !== null ? Number(val) : null;
                            break;
                        case "Currency": {
                            const convertedCost = val ? await ExchangeCurrency(Number(val), ConvertRate) : null;
                            val = convertedCost ? Number(convertedCost?.toFixed(CurencyDecimalPlace)) : null;
                            break;
                        }
                        case "Date":
                            val = val ? moment(val) : null;
                            break;
                        case "CheckBox":
                            val = val === "1" || val === 1 || val === true || val === "true";
                            break;
                        default:
                            val = normalizeValue(val);
                            break;
                    }
                    if (["mobile", "phone", "postcode"].includes(item.fieldKey)) {
                        val = val === "0" || val === 0 ? null : val;
                    }
                    formattedValue[item.fieldKey] = val;
                })
        );
        return formattedValue;
    }
    async function preprocessFormValues1(value, allFieldStructure) {
        const formattedValue = { ...value };
        formattedValue.customFieldValues = await Promise.all(
            (formattedValue.customFieldValues || []).map(async cf => {
                const fieldDef = allFieldStructure.find(f => f.fieldId === cf.fieldId);
                if (!fieldDef) return cf;
                let newValue;
                switch (fieldDef.fieldType) {
                    case "Dropdown":
                    case "Number":
                    case "Percentage":
                    case "Currency":
                        newValue = cf.value ? Number(cf.value) : null;
                        break;
                    case "Multi-Dropdown":
                    case "Date":
                        newValue = cf.value ? String(cf.value) : null;
                        break;
                    default:
                        newValue = cf.value;
                        break;
                }
                return { ...cf, value: newValue };
            })
        );
        await Promise.all(
            allFieldStructure
                .filter(f => f.customFieldType === "Default")
                .map(async item => {
                    let val = formattedValue[item.fieldKey] ?? null;
                    switch (item.fieldType) {
                        case "Dropdown": {
                            if (DEFAULT_DROPDOWN_FIELDS.includes(item.fieldKey)) {
                                val = normalizeValue(val)
                            } else {
                                val = val !== undefined && val !== null ? Number(val) : null;
                            }
                            break;
                        }
                        case 'MultiFileUpload':
                            val = val || [];
                            break;
                        case "Number":
                        case "Percentage":
                        case "Currency":
                            val = val ? Number(val) : null;
                            break;
                        case "Multi-Dropdown":
                        case "Date":
                            val = val ? String(val) : null;
                            break;
                        default:
                            val = normalizeValue(val);
                            break;
                    }
                    if (["mobile", "phone", "postcode"].includes(item.fieldKey)) {
                        val = val === "0" || val === 0 ? null : val;
                    }
                    formattedValue[item.fieldKey] = val;
                })
        );
        return formattedValue;
    }
    async function preprocessFormDisplay(value, allFieldStructure) {
        const formattedValue = { ...value };
        formattedValue.customFieldValues = await Promise.all(
            (formattedValue.customFieldValues || []).map(async cf => {
                const fieldDef = allFieldStructure.find(f => f.fieldId === cf.fieldId);
                if (!fieldDef) return cf;
                let newValue;
                switch (fieldDef.fieldType) {
                    case "Multi-Dropdown":
                        newValue = cf.option;
                        break;
                    case "Dropdown":
                        newValue = cf.option;
                        break;
                    case "Number":
                        newValue = cf.value ? Number(cf.value) : null;
                        break;
                    case "Percentage":
                        newValue = cf.value ? `% ${Number(cf.value)}` : null;
                        break;
                    case "Currency": {
                        const convertedCost = cf.value ? await ExchangeCurrency(Number(cf.value), ConvertRate) : null;
                        newValue = convertedCost ? `${defaultCurrency?.symbol} ${Number(convertedCost?.toFixed(CurencyDecimalPlace))?.toLocaleString()}` : null;
                        break;
                    }
                    case "Date":
                        newValue = cf.value ? formatDate(cf.value, profile) : null;
                        break;
                    case "CheckBox":
                        newValue = (cf.value === "1" || cf.value === 1 || cf.value === true || cf.value === "true") ? "Yes" : "No";
                        break;
                    default:
                        newValue = cf.value;
                        break;
                }
                return { ...cf, value: newValue };
            })
        );
        await Promise.all(
            allFieldStructure
                .filter(f => f.customFieldType === "Default")
                .map(async item => {
                    let val = formattedValue[item.fieldKey] ?? null;
                    switch (item.fieldType) {
                        // case "Multi-Dropdown":
                        //     val = val ? val.split(",").map(id => Number(id)) : [];
                        //     break;
                        case 'MultiFileUpload':
                            val = val || [];
                            break;
                        case "Dropdown": {
                            if (DEFAULT_DROPDOWN_DISPLAY_FIELDS[item.fieldKey]) {
                                const displayKey = DEFAULT_DROPDOWN_DISPLAY_FIELDS[item.fieldKey];
                                val = displayKey
                                    ? normalizeValue(formattedValue[displayKey])
                                    : normalizeValue(val);
                            } else {
                                val = val !== undefined && val !== null ? normalizeValue(val) : null;
                            }
                            break;
                        }
                        case "Number":
                            val = val !== undefined && val !== null ? Number(val) : null;
                            break;
                        case "Percentage":
                            val = val !== undefined && val !== null ? `% ${Number(val)}` : null;
                            break;
                        case "Currency": {
                            const convertedCost = val ? await ExchangeCurrency(Number(val), ConvertRate) : null;
                            val = convertedCost ? `${defaultCurrency?.symbol} ${Number(convertedCost?.toFixed(CurencyDecimalPlace))?.toLocaleString()}` : null;
                            break;
                        }
                        case "Date":
                            val = val ? formatDate(val, profile) : null;
                            break;
                        case "CheckBox":
                            val = (val === "1" || val === 1 || val === true || val === "true") ? "Yes" : "No";
                            break;
                        default:
                            val = normalizeValue(val);
                            break;
                    }
                    if (["mobile", "phone", "postcode"].includes(item.fieldKey)) {
                        val = val === "0" || val === 0 ? null : val;
                    }
                    formattedValue[item.fieldKey] = val;
                })
        );
        return formattedValue;
    }
    const setData = async (value) => {
        if (value !== undefined) {
            const formattedValue = await preprocessFormValues(value, allFieldStructure);
            const formattedValue1 = await preprocessFormValues1(value, allFieldStructure);
            const formatteddisplayValue = await preprocessFormDisplay(value, allFieldStructure);
            const formValues = allFieldStructure.reduce((acc, item) => {
                const fieldKeys = item.fieldKey;
                let fieldValue;

                if (item.customFieldType === "Custom") {
                    const cf = formattedValue?.customFieldValues?.find(cf => cf.fieldId === item.fieldId);
                    fieldValue = cf ? cf.value ?? null : null;
                } else {
                    fieldValue = formattedValue[fieldKeys];
                }
                acc[fieldKeys] =
                    item.fieldType === "Multi-Dropdown"
                        ? fieldValue || []
                        : normalizeValue(fieldValue) ?? null;

                return acc;
            }, {});
            const updatedFieldStructure = allFieldStructure.map(item => {
                const fieldKeys = item.fieldKey;
                let fieldValue;
                if (item.customFieldType === "Custom") {
                    const cf = formattedValue1?.customFieldValues?.find(cf => cf.fieldId === item.fieldId);
                    fieldValue = cf ? cf.value ?? null : null;
                } else {
                    fieldValue = formattedValue1[fieldKeys];
                }
                // if (item.fieldType === "Date" && fieldValue) {
                //     fieldValue = moment(fieldValue).format("YYYY-MM-DD");
                // }
                return {
                    ...item,
                    value: fieldValue
                    // type === "Edit"
                    //     ? (item.fieldType === "Multi-Dropdown"
                    //         ? fieldValue ? fieldValue.join(",") : []
                    //         : normalizeValue(fieldValue) ?? null)
                    //     : (item.fieldType === "Multi-Dropdown"
                    //         ? []
                    //         : null)
                };
            });
            if (drawerPage !== "CloneLead") {
                if (formattedValue.approved_for !== "None") { setApproveOpen(true); setApproveCondition(true); }
                else { setApproveOpen(false); setApproveCondition(false); }
            }
            setAllFieldStructure(updatedFieldStructure)
            setAssignOwner(formattedValue.leadOwner);
            form.setFieldsValue(formValues);
            setRelatedLead(formattedValue.related_lead_id);
            // ── Keyed upload state ─────────────────────────────────────────────
            setImage('leadProfile', formattedValue.leadProfile ?? null);
            setDeleteOption('leadProfile', !!(formattedValue.leadProfile && formattedValue.leadProfile !== ''));
            setFileList('leadFiles', formattedValue.leadFiles || []);
            // ──────────────────────────────────────────────────────────────────
            setLeadId(formattedValue.leads_id);
            setStates({ ...states, selectedRowKeys: [formattedValue.leads_id] });
            setCountry(formattedValue.country);
            const transformedItem = {
                ...value,
                created_at: formattedValue.created_at ? convertAndFormatDateTime(formattedValue.created_time ? `${formattedValue.created_at} ${formattedValue.created_time}` : formattedValue.created_at, companyProfile, profile) : "",
                modified_at: formattedValue.modified_at ? convertAndFormatDateTime(formattedValue.modified_time ? `${formattedValue.modified_at} ${formattedValue.modified_time}` : formattedValue.modified_at, companyProfile, profile) : "",
            };
            setDisplayData(transformedItem);
            const groupedData = customGroups
                .map(group => {
                    const groupId = group.customFieldGroupId;
                    const fields = (customFields?.[groupId] || [])
                        .filter(field =>
                            !excludedFields.includes(field.fieldKey) &&
                            !excludedType.includes(field.fieldType) &&
                            field.fieldVisible === 'Yes'
                        )
                        .map(field => {
                            let value;
                            if (field.customFieldType === "Custom") {
                                const cf = formatteddisplayValue?.customFieldValues?.find(
                                    c => c.fieldId === field.fieldId
                                );
                                value = cf?.value ?? null;
                            } else {
                                value = formatteddisplayValue[field.fieldKey];
                            }
                            return {
                                ...field,
                                value:
                                    field.fieldType === "Multi-Dropdown"
                                        ? value || []
                                        : normalizeValue(value) ?? null
                            };
                        });
                    return {
                        ...group,
                        fields
                    };
                });
            setArrayDisplayData(groupedData);
        }
    };
    async function deleteMenu(id) {
        setValues([id]); setPopup(true); setPopupType("Delete"); setAction("DeleteNav");
    }
    async function ConvertApi(id) {
        setValues([id]); setPopup(true); setPopupType("Convert"); setAction("ConvertNav");
    }
    async function getSharingPermissions(id) {
        if (id) { setDataPermissions(id); } else { setDataPermissions("Read,Update,Delete,Sharing"); }
    }
    const CloseDrawer = () => {
        setCancelConfirmOpen(false);
        setApproveOpen(false);
        setApproveCondition(false);
        setAssignOwner(null);
        const allValues = form.getFieldsValue(true);
        const resetTitles = {};
        Object.keys(allValues).forEach(key => {
            if (key.startsWith("title-")) {
                resetTitles[key] = undefined;
            }
        });
        form.setFieldsValue(resetTitles);
        const formValues = allFieldStructure
            .filter(item => item.fieldType !== "MultiFileUpload" && item.fieldType !== "FileUpload")
            .reduce((acc, item) => {
                acc[item.fieldKey] =
                    item.fieldType === "Multi-Dropdown" ? [] :
                        item.fieldType === "CheckBox" ? false : null;
                return acc;
            }, {});
        form.setFieldsValue(formValues);
        // ── Reset keyed upload state ───────────────────────────────────────────
        setImages({});
        setDeleteOptions({});
        setFileLists({});
        // ──────────────────────────────────────────────────────────────────────
        setStates({ ...states, selectedRowKeys: [] });
        setDrawerPage();
        setCountry(); setState(); setCity();
        if (FromPage !== "EntityUpdate" && ShortCut !== "Shortcut") { GetAll(); setCratePage(); }
        if (ShortCut === "Shortcut") { setCratePage(); }
        if (drawerPage === "CloneLead" || ShortCut === "Shortcut") { PageCancel(); }
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false));
        setAllFieldStructure([])
        prevValues.current = { UrlId: "", FromPage: "" };
        setUiReady(false);
    };
    const CloseDrawerNew = () => {
        setCancelConfirmOpen(false);
        setDrawerPage();
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false));
        const allValues = form.getFieldsValue(true);
        const resetTitles = {};
        Object.keys(allValues).forEach(key => {
            if (key.startsWith("title-")) {
                resetTitles[key] = undefined;
            }
        });
        form.setFieldsValue(resetTitles);
    };
    async function getData(leadId) {
        try {
            if (drawerPage === "CloneLead") {
                const responseData = await LeadDetailData(leadId);
                const response = responseData.data;
                getSharingPermissions(undefined);
                setData(response);
            } else {
                const responseData = await LeadDetailData(leadId);
                if (!responseData.allow) throw new Error();
                const response = responseData.data;
                getSharingPermissions(response?.sharingPermission?.sharePermission);
                setData(response);
            }
        } catch (error) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({ key, type: 'error', content: `This record is no longer available. It may have been deleted or moved`, duration: 0 });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) { clearInterval(interval); message.destroy(key); PageCancel(); }
                else { message.open({ key, type: 'error', content: `This record is no longer available. It may have been deleted or moved`, duration: 0 }); }
            }, 1000);
        }
    }
    async function getData1(leadId, hideMessage, isAutomation, updateResponse) {
        try {
            const responseData = await LeadDetailData(leadId);
            hideMessage();
            if (isAutomation) { successMessage("Automation rule triggered", updateResponse.data[0].message); }
            else { message.success(<span>Lead <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successfully</span>); }
            if (!responseData.allow) throw new Error();
            const response = responseData.data;
            getSharingPermissions(response?.sharingPermission?.sharePermission);
            setData(response);
            setTrigger("activity");
            loadingRef.current = false;
            setDoubleClick(false);
            CloseDrawerNew();
        } catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false);
            if (isAutomation) { successMessage("Automation rule triggered", updateResponse.data[0].message); }
            else { message.success(<span>Lead <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successfully</span>); }
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({ key, type: 'error', content: `This record is no longer available. It may have been deleted or moved`, duration: 0 });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) { clearInterval(interval); message.destroy(key); PageCancel(); }
                else { message.open({ key, type: 'error', content: `This record is no longer available. It may have been deleted or moved`, duration: 0 }); }
            }, 1000);
        }
    }
    const { NavigationDecrypted } = useNavigationDecrypted();
    async function getEntityAvalibitlity() {
        let dataFound = true;
        try {
            const response = await NavigationDecrypted(UrlId[1]);
            if (response) { setLeadId(response); dataFound = true; getData(response); }
            else { dataFound = false; }
        } catch (error) { dataFound = false; }
        if (!dataFound) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({ key, type: 'error', content: `This record is no longer available. It may have been deleted or moved`, duration: 0 });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) { clearInterval(interval); message.destroy(key); PageCancel(); }
                else { message.open({ key, type: 'error', content: `This record is no longer available. It may have been deleted or moved`, duration: 0 }); }
            }, 1000);
        }
    }
    const handleCountryChange = async (value, option) => {
        setCountry(value);
        if (option.key) {
            try {
                const response = await getStateData(option.key); setAllState(response); setState(); setCity(); setAllCity([]);
                form.setFieldsValue({ state: null, city: null })
            }
            catch (error) { message.error(error); }
        } else {
            setAllState([]); setAllCity([]); setState(); setCity(); form.setFieldsValue({
                state: null, city: null
            })
        }
    };
    const handleStateChange = async (value, option) => {
        setState(value);
        if (option.key) {
            try {
                const response = await getCityData(option.key); setAllCity(response); setCity(); form.setFieldsValue({
                    city: null
                })
            }
            catch (error) { message.error(error); }
        } else {
            setAllCity([]); setCity(); form.setFieldsValue({
                city: null
            })
        }
    };
    const handleCityChange = (value) => { setCity(value); };
    const fetchDropdownOptions = async () => {
        // Collect all unique dropdownIds from all custom fields
        const allAttrs = Object.values(customFields || {}).flat();
        const dropdownIds = [...new Set(
            allAttrs
                .filter(attr => attr.dropdownId)
                .map(attr => attr.dropdownId)
        )];
        if (!dropdownIds.length) return;
        // Fetch all in parallel
        const results = await Promise.allSettled(
            dropdownIds.map(id => findAllCustomOptionsByDropdown(id))
        );
        const map = results.reduce((acc, result, index) => {
            const attr = allAttrs.find(a => a.dropdownId === dropdownIds[index]);
            if (result.status === 'fulfilled') {
                acc[dropdownIds[index]] = result.value
                    .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
                    .map(item => ({
                        value: item.customDropdownOptionId,
                        label: item.option,
                    }));
            } else {
                acc[dropdownIds[index]] = [];
                message.error(`Failed to load "${attr?.dropdownType}" dropdown`);
            }
            return acc;
        }, {});
        setOptionsMap(map);
    };
    const fetchAll1 = async () => {
        await Promise.allSettled([
            fetchDropdownOptions(),
        ]);
        setTimeout(() => {
            setUiReady(true);
        }, 1000);
    };
    const fetchAll = async () => {
        await Promise.allSettled([
            getCountry(),
            UserDetailsApi(),
            AccountApi(),
        ]);
    };
    useEffect(() => {
        if (FromPage) {
            scroolup();
            fetchCustomGroupsAndFields()
        }
    }, [FromPage]);
    useEffect(() => {
        if (FromPage && displayData && customFields) {
            fetchAll1();
        }
    }, [FromPage, displayData, customFields]);
    useEffect(() => {
        if (FromPage && editField && displayData) {
            fetchAll();
        }
    }, [FromPage, editField, displayData]);
    const onFinishFailed = () => { message.error("Please fill out all required fields"); };
    const handleNoteClick = (value) => { setNotePopup(true); setPopupType(value); setNaCTrigger("trigger"); setPage("Entity"); };
    const handleCallLogClick = (value) => { setCallLogPopup(true); setPopupType(value); setNaCTrigger("trigger"); };
    const AssignToFucntion = () => {
        if (approveCondition) { setApproveOpen(true); }
        else { setValues([leadId]); setPopup(true); setPopupType("Change Owner"); setAction("SingleChangeOwner"); }
    };
    const HandleAddCampaignClick = () => { setCampaignPopup(true); };
    const HandleAddOutreachClick = () => { setOutreachPopup(true); };
    const HandleShareClick = () => { setSharePopup(true); };
    const CloneLead = () => { setDrawerPage("CloneLead"); };
    const getUserDetail = async () => {
        if ((UrlId === undefined || UrlId === null) && profile.department === "Sales") {
            form.setFieldsValue({ leadOwner: profile.userId });
        }
    };
    const fetchAlld = async () => {
        await Promise.allSettled([
            getSeniorityLevel(),
            getLeadStatus(),
            getEntityAvalibitlity(),
        ])
    };
    useEffect(() => {
        if (allFieldStructure.length) {
            const currentUrlId = JSON.stringify(UrlId);
            const currentFromPage = FromPage;
            if (prevValues.current.UrlId === currentUrlId && prevValues.current.FromPage === currentFromPage) return;
            prevValues.current = { UrlId: currentUrlId, FromPage: currentFromPage };
            if (FromPage) {
                if (FromPage === "EntityUpdate") {
                    fetchAlld();
                } else {
                    const formValues = allFieldStructure
                        .filter(item => item.fieldType !== "MultiFileUpload" && item.fieldType !== "FileUpload")
                        .reduce((acc, item) => {
                            acc[item.fieldKey] =
                                item.fieldType === "Multi-Dropdown" ? [] :
                                    item.fieldType === "CheckBox" ? false : undefined;
                            return acc;
                        }, {});
                    form.setFieldsValue(formValues);
                    // ── Reset keyed upload state on create ────────────────────
                    setImages({});
                    setDeleteOptions({});
                    setFileLists({});
                    setDisplayData("Create")
                    // ──────────────────────────────────────────────────────────
                    setLeadId();
                    setStates({ ...states, selectedRowKeys: [] });
                    setCountry(); setState(); setCity();
                    getUserDetail();
                    setRelatedLead();
                    setDataPermissions("Read,Update,Delete,Sharing");
                    setEdit(true);
                    setEditField(true);
                }
            }
        }
    }, [UrlId, FromPage, allFieldStructure]);
    useEffect(() => {
        if (drawerPage === "CloneLead") {
            getData(leadId);
            setDataPermissions("Read,Update,Delete,Sharing");
            setEditField(true);
            setEdit(true);
        }
    }, [drawerPage]);

    const closeMailComposr = () => { setMailOpen(false); };
    const CreateTask = (id) => {
        setCreatePageTask("ListingLead");
        setNaCTrigger("trigger");
        setTaskProp({ type: "Lead", ids: [id] });
    };
    const CreateMail = () => {
        if (emailactiontype) { setPopupMessage(true); }
        else { setNaCTrigger("trigger"); setMailOpen(true); }
    };
    const CreateMeeting = (LId, firstname, lastname, mail) => {
        if (emailactiontype) { setPopupMessage(true); }
        else {
            setMeetingAttendees([{ id: LId, name: `${firstname} ${lastname}`, type: "Leads", email: mail }]);
            setNaCTrigger("trigger");
            setMeetingOpen(true);
        }
    };
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const ViewDetailPage = (id, entity) => { ExcryptedNavigation("Nav", id, entity, history, null, null, null); };
    const handleEditChange = () => {
        if (approveCondition) { setApproveOpen(true); }
        else { setEditField(true); setEdit(true); dispatch(setEditCall(true)); setTrigger(""); setApproveOpen(false); }
    };
    const handleConvertChange = () => {
        if (approveCondition) { setApproveOpen(true); }
        else { ConvertApi(leadId); setApproveOpen(false); }
    };
    const handleMergeclick = () => {
        if (approveCondition) { setApproveOpen(true); setMergeOpen(false); }
        else { setNaCTrigger("trigger"); setApproveOpen(false); setMergeOpen(true); }
    };
    const moreAction = "Yes";
    const MoreAction = ({ closeDropdown }) => (
        <div style={{ padding: "0px", width: "100%", height: "100%" }}>
            <Link to={combinedUrl} onClick={(edit || !canCreate(permissions, 2002)) ? undefined : () => { CloneLead(); closeDropdown(); }} className={`text_icon ${(edit || !canCreate(permissions, 2002)) ? "disabled_link" : ''}`}>
                <CloneIcon height={15} width={15} marginRight={5} /> Clone
            </Link>
            {/* <Link to={combinedUrl} onClick={(edit || !canShare(dataPermissions, "Sharing")) ? undefined : () => { HandleShareClick(); closeDropdown(); }} className={`text_icon ${(edit || !canShare(dataPermissions, "Sharing")) ? 'disabled_link' : ""}`}> */}
            <Link to={combinedUrl} onClick={(edit || (profile.userId !== displayData?.lead_owner)) ?
                undefined : () => { HandleShareClick(); closeDropdown() }}
                className={`text_icon ${(edit || (profile.userId !== displayData?.lead_owner)) ? 'disabled_link' : ""}`}>
                <ShareIcon height={14} width={14} marginRight={5} /> Share
            </Link>
            <Link to={combinedUrl} onClick={(!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2003)) ? () => { AssignToFucntion(); closeDropdown(); } : undefined} className={`text_icon ${(!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2003)) ? "" : 'disabled_link'}`}>
                <ChangeOwnerIcon height={15} width={15} marginRight={5} /> Change Owner
            </Link>
            <Link to={combinedUrl} onClick={(edit || !canCreate(permissions, 2002)) ? undefined : () => { handleNoteClick("Create"); closeDropdown(); }} className={`text_icon ${(edit || !canCreate(permissions, 2002)) ? "disabled_link" : ''}`}>
                <NotesIcon height={15} width={15} marginRight={5} /> Add a Note
            </Link>
            <Link to={combinedUrl} onClick={(!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2003)) ? () => { handleMergeclick(); closeDropdown(); } : undefined} className={`text_icon ${(!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2003)) ? "" : 'disabled_link'}`}>
                <MergeIcon height={15} width={15} marginRight={5} /> Merge Duplicates
            </Link>
            <Link to={combinedUrl} onClick={(edit || !canCreate(permissions, 2002)) ? undefined : () => { HandleAddCampaignClick(); closeDropdown(); }} className={`text_icon ${(edit || !canCreate(permissions, 2002)) ? "disabled_link" : ''}`}>
                <CampaignIcon height={15} width={15} marginRight={5} /> Add to Campaign
            </Link>
            {assignOwner === profile.userId ? (
                <Link to={combinedUrl} onClick={(edit || !canCreate(permissions, 2002)) ? undefined : () => { HandleAddOutreachClick(); closeDropdown(); }} className={`text_icon ${(edit || !canCreate(permissions, 2002)) ? "disabled_link" : ''}`}>
                    <EmailseqQueueIcon height={15} width={15} marginRight={5} /> Add to Outreach Sequence
                </Link>
            ) : <></>}
        </div>
    );
    MoreAction.propTypes = { closeDropdown: PropTypes.func.isRequired };
    const ButtonActions = [
        { Actions: <div className={(!canCreate(permissions, 2002)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'} role="button" tabIndex={0} title='Send Email' onClick={(!canCreate(permissions, 2002)) ? undefined : () => CreateMail()} onKeyDown={(event) => { if (canCreate(permissions, 2002) && (event.key === 'Enter' || event.key === ' ')) { CreateMail(); } }} aria-label='mail'><EmailIcon height={20} width={20} /></div> },
        { Actions: <div className={(!canCreate(permissions, 2002)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'} role="button" tabIndex={0} title='Schedule a Meeting' onClick={(!canCreate(permissions, 2002)) ? undefined : () => CreateMeeting(leadId, displayData?.firstName, displayData?.lastName, displayData?.primaryEmail)} onKeyDown={(event) => { if (canCreate(permissions, 2002) && (event.key === 'Enter' || event.key === ' ')) { CreateMeeting(leadId, displayData?.firstName, displayData?.lastName, displayData?.primaryEmail); } }} aria-label='meeting'><CalendarIcon height={20} width={20} /></div> },
        { Actions: <div className={(!canCreate(permissions, 2002)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'} role="button" tabIndex={0} title='Create Task' onClick={(!canCreate(permissions, 2002)) ? undefined : () => CreateTask(leadId)} onKeyDown={(event) => { if (canCreate(permissions, 2002) && (event.key === 'Enter' || event.key === ' ')) { CreateTask(leadId); } }} aria-label='task'><TaskIcon height={20} width={20} /></div> },
        { Actions: <div className={(!canCreate(permissions, 2002)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'} role="button" tabIndex={0} title='Log a Call' onClick={(!canCreate(permissions, 2002)) ? undefined : () => handleCallLogClick("Create")} onKeyDown={(event) => { if (canCreate(permissions, 2002) && (event.key === 'Enter' || event.key === ' ')) { handleCallLogClick("Create"); } }} aria-label='phone'><CallLogIcon height={20} width={20} /></div> },
    ];
    const LeadInfos = {
        profile: images.leadProfile ?? null,
        Classname: "LeadIcon",
        letterIcon: displayData?.firstName,
        name: `${displayData?.title ? displayData?.titleName : ""} ${displayData?.firstName} ${displayData?.lastName}`,
        subName: displayData?.designation && displayData?.designation !== "" ? displayData?.designation : "Designation",
        mainAction: (
            <Button className="button_colors" size="small" style={{ width: "60%" }}
                onClick={canUpdateDelete(permissions, dataPermissions, "Update", 2003) ? () => handleConvertChange() : undefined}
                disabled={!canUpdateDelete(permissions, dataPermissions, "Update", 2003)}>
                <ConvertIcon height={25} width={25} /> Convert to Contact
            </Button>
        ),
    };
    const EditOpenForDrawer = () => { setEdit(true); dispatch(setEditCall(true)); };
    const isEqual = (a, b) => {
        if (a === b) return true;
        // if (typeof a !== typeof b) return false;
        if (
            (typeof a === "number" && typeof b === "string") ||
            (typeof a === "string" && typeof b === "number")
        ) {
            return String(a) === String(b);
        }
        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }
        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;
            return keysA.every(key => isEqual(a[key], b[key]));
        }
        return false;
    };
    const getChangedFields = (currentStructure, initialStructure) => {
        return currentStructure.filter((currField) => {
            const initField = initialStructure.find((f) => f.fieldId === currField.fieldId);
            if (!initField) return true;
            const currValue = currField.value;
            const initValue = initField.value;
            return !isEqual(currValue, initValue);
        });
    };
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick(true);
        let hideMessage;
        const currentStructure = await Promise.all(
            allFieldStructure.map(async (field) => {
                let value;
                switch (field.fieldType) {
                    case 'FileUpload':
                        value = normalizeValue(images[field.fieldKey] ?? null);
                        break;
                    case 'MultiFileUpload':
                        value = fileLists[field.fieldKey] || [];
                        break;
                    case 'Date':
                        value = values[field.fieldKey]
                            ? moment(values[field.fieldKey]).format("YYYY-MM-DD")
                            : null;
                        break;
                    case 'Number':
                        // string → number or null
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? Number(values[field.fieldKey])
                            : null;
                        break;
                    case 'Percentage':
                        // string → number or null
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? Number(values[field.fieldKey])
                            : null;
                        break;
                    case 'Currency':
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? await convertCurrency(ConvertRate, Number(values[field.fieldKey]))
                            : null;
                        break;
                    case 'Multi-Dropdown':
                        value = values[field.fieldKey] && values[field.fieldKey].length > 0
                            ? values[field.fieldKey].join(",")
                            : null;
                        break;
                    case 'CheckBox':
                        value = values[field.fieldKey] ?? false;
                        break;
                    default:
                        value = normalizeValue(values[field.fieldKey] ?? null);
                        break;
                }
                return { ...field, value };
            })
        );
        const changedFields = getChangedFields(currentStructure, allFieldStructure);
        if (changedFields.length === 0) {
            getData(leadId); scroolup(); message.success("Lead updated");
            loadingRef.current = false; setDoubleClick(false); CloseDrawerNew();
            return;
        }
        const defaultChanges = {};
        const customFieldValues = [];

        changedFields.forEach((field) => {
            if (field.customFieldType === "Default") {
                defaultChanges[field.fieldKey] = field.value;
            } else {
                const obj = {
                    entityId: field.entityId,
                    fieldId: field.fieldId,
                    value: field.value,
                };
                customFieldValues.push(obj);
            }
        });
        const payload = {
            ...defaultChanges,
            ...(customFieldValues.length > 0 && { customFieldValues }),
        };
        if (displayData.related_lead_id !== relatedLead) {
            payload.relatedLeadId = normalizeValue(relatedLead);
        }
        try {
            hideMessage = message.loading("Loading...", 0);
            if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") {
                const response = await LeadUpdate(payload, leadId);
                if (response.status === 200) {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data); setIsModalVisible1(true);
                        loadingRef.current = false; setDoubleClick(false); hideMessage();
                    } else {
                        const isAutomation = response.data[0].message === AutomationMessage;
                        const isApproval = response.data[0].message === ApprovalMessage;
                        const ownerChanged = displayData?.leadOwner !== values.leadOwner;
                        if (isApproval) {
                            hideMessage(); getData(leadId); scroolup();
                            successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                            loadingRef.current = false; setDoubleClick(false); CloseDrawerNew();
                        } else if (ownerChanged) {
                            hideMessage();
                            if (isAutomation) { successMessage("Automation rule triggered", response.data[0].message); }
                            else { message.success(<span>Lead <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully</span>); }
                            dispatch(setEditCall(false)); history.push('/Home/leads');
                        } else { getData1(leadId, hideMessage, isAutomation, response); scroolup(); }
                    }
                }
            }
            else {
                const response = await LeadSave(payload);
                if (response.status === 201) {
                    const isAutomation = response?.data === AutomationMessage;
                    const isApproval = response?.data === ApprovalMessage;
                    hideMessage();
                    if (isApproval) { successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve"); }
                    else if (isAutomation) { successMessage("Automation rule triggered", response?.data); }
                    else { message.success(response?.data); }
                    loadingRef.current = false; setDoubleClick(false); CloseDrawer();
                }
            }
        } catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false);
            message.error(error);
        }
    };
    const onSubmitClone = (value) => {
        if (displayData.accountName !== value.accountName) {
            Modal.confirm({
                icon: null,
                className: "customice-confirm-modal",
                title: (<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}><ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} /><span>Account Changed</span></div>),
                content: (<div><p>You are modifying the account name for this lead only. If other leads use the same account, their account names must be updated manually.</p></div>),
                centered: true, okText: "Continue", cancelText: "Cancel",
                okButtonProps: { className: "button_colorsModal" },
                cancelButtonProps: { className: "gray-buttonModal" },
                onOk() { onSubmit(value); },
                onCancel() { scroolup(); getData(leadId); },
            });
        } else { onSubmit(value); }
    };
    const CloseDrawer2 = () => {
        scroolup(); getData(leadId); setEditField(false); setEdit(false);
        dispatch(setEditCall(false)); setDrawerPage();
        const allValues = form.getFieldsValue(true);
        const resetTitles = {};
        Object.keys(allValues).forEach(key => {
            if (key.startsWith("title-")) {
                resetTitles[key] = undefined;
            }
        });
        form.setFieldsValue(resetTitles);
    };
    const PageCancel1 = () => {
        if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") { CloseDrawer2(); }
        else if (FromPage === "EntityUpdate" && drawerPage === "CloneLead") { setCancelConfirmOpen(true); }
        else { setCancelConfirmOpen(true); }
    };
    const getRefreshtheTable = () => { CloseDrawer2(); setTrigger("activity"); };
    useEffect(() => {
        if (account.length && displayData?.accountName) {
            const matched = account.find(acc => acc.value === displayData.accountName);
            if (matched) {
                setDataDisables({ isDisable: matched.data.status === "Qualified", allow: matched.data.status === "Qualified", id: matched.data.accountID, profile: matched.data.accountProfile });
            } else {
                setDataDisables({ isDisable: false, allow: false, id: null, profile: null });
            }
        }
    }, [displayData, account]);
    const normalizeValue2 = (value) => value?.toLowerCase()?.trim() || '';
    const getSeniorityLevelId = (senioritys) => {
        const normalized = normalizeValue2(senioritys);
        const match = seniority.find(item => item.option.toLowerCase().includes(normalized));
        return match || null;
    };
    const attributes = [
        { key: "firstName", label: "First Name" },
        { key: "lastName", label: "Last Name" },
        { key: "primaryEmail", label: "Primary Email" },
        { key: "designation", label: "Designation" },
        { key: "seniorityLevel", label: "Seniority Level" },
        { key: "linkedinUrl", label: "Linkedin Url" },
        { key: "country", label: "Country" },
        { key: "state", label: "State" },
        { key: "city", label: "City" },
    ];
    const updateEnrichdata = async (value) => {
        form.setFieldsValue({
            firstName: value.firstName, lastName: value.lastName,
            primaryEmail: value.primaryEmail, designation: value.designation,
            seniorityLevel: value.seniorityLevelId, country: value.country,
            linkedinUrl: value.linkedinUrl,
        });
        setCountry(value.country);
        try {
            const response = await getCountryData();
            if (value.country) {
                const countryInfo = response.find(c => c.country === value.country);
                if (countryInfo) { getState(value, countryInfo.countryId); }
            }
        } catch (error) { message.error(error); }
    };
    const showConfirm2 = (newStructure) => {
        const tableData = attributes.map((attr, index) => ({
            key: index, attribute: attr.label,
            oldValue: displayData?.[attr.key] ?? "-",
            enrichedValue: newStructure?.[attr.key] ?? "-",
        }));
        const columnss = [
            { title: "Attribute", dataIndex: "attribute", key: "attribute", width: "30%", ellipsis: true, render: (text) => <Typography.Paragraph ellipsis={{ tooltip: text }} style={{ marginBottom: 0 }}>{text}</Typography.Paragraph> },
            { title: "Lead Data", dataIndex: "oldValue", key: "oldValue", width: "35%", ellipsis: true, render: (text) => <Typography.Paragraph ellipsis={{ tooltip: text }} style={{ marginBottom: 0 }}>{text}</Typography.Paragraph> },
            { title: "Enriched Data", dataIndex: "enrichedValue", key: "enrichedValue", width: "35%", ellipsis: true, render: (text) => <Typography.Paragraph ellipsis={{ tooltip: text }} style={{ marginBottom: 0 }}>{text}</Typography.Paragraph> },
        ];
        const modal = Modal.confirm({
            title: (<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}><ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} /><span>Lead Enrichment</span></div>),
            icon: null, width: 1000,
            content: (
                <div>
                    <p>Are you sure, you want to add enriched data?</p>
                    <div className="table-bordered leaderboard-table table-responsive">
                        <Table dataSource={tableData} columns={columnss} rowKey={(record, index) => index?.toString()} pagination={false} tableLayout="fixed" />
                    </div>
                </div>
            ),
            className: "customice-confirm-modal", centered: true, okText: "Enrich", cancelText: "Cancel",
            okButtonProps: { className: "button_colorsModal" },
            cancelButtonProps: { className: "gray-buttonModal" },
            okCancel: true,
            onOk() { updateEnrichdata(newStructure); },
            onCancel() { modal.destroy(); },
        });
    };
    async function ConnectwithLead(paramsEmail) {
        if (loadingRef.current) return;
        loadingRef.current = true; setDoubleClick(true);
        let hideMessage;
        try {
            hideMessage = message.loading("Collecting lead information...", 0);
            const response = await hunterioLeadDetails(profile.companyId, paramsEmail);
            const LeadData = response.data;
            const seniorityLevel = getSeniorityLevelId(LeadData?.employment?.seniority);
            const newStructure = {
                "firstName": LeadData?.name?.givenName ? LeadData?.name?.givenName : displayData?.firstName,
                "lastName": LeadData?.name?.familyName ? LeadData?.name?.familyName : displayData?.lastName,
                "primaryEmail": LeadData?.email ? LeadData?.email : displayData?.primaryEmail,
                "designation": LeadData?.employment?.title ? LeadData?.employment?.title : displayData?.designation,
                "seniorityLevelId": seniorityLevel?.customDropdownOptionId ? seniorityLevel?.customDropdownOptionId : displayData?.seniorityLevelId,
                "seniorityLevel": seniorityLevel?.option ? seniorityLevel?.option : displayData?.seniorityLevel,
                "linkedinUrl": LeadData?.linkedin?.handle ? `https://www.linkedin.com/in/${LeadData?.linkedin?.handle}` : null,
                "country": LeadData?.geo?.country ? LeadData?.geo?.country : displayData?.country,
                "state": LeadData?.geo?.state ? LeadData?.geo?.state : null,
                "city": LeadData?.geo?.city ? LeadData?.geo?.city : null,
            };
            message.success("Lead enriched successful");
            loadingRef.current = false; setDoubleClick(false); hideMessage();
            showConfirm2(newStructure);
        } catch (error) {
            hideMessage(); loadingRef.current = false; setDoubleClick(false); message.error(error);
        }
    }
    const handleFinish = (values) => {
        if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") { onSubmitClone(values); }
        else { onSubmit(values); }
    };
    const memoUrlId = useMemo(() => (UrlId ? [UrlId[0], leadId] : null), [UrlId, leadId]);
    const updatePsqq = useMemo(() => ({ permission: permissions, dataPermission: dataPermissions, type: "Update", PId: 2003 }), [permissions, dataPermissions]);
    const getDetailsDatas = useCallback(() => getData(leadId), [leadId]);
    const MemoLeadStatusBar = useMemo(() => (
        <LeadStatusBar UrlId={memoUrlId} getDetailsData={getDetailsDatas} leadStatusData={leadStatusData}
            displayData={displayData} setNaCTrigger={setNaCTrigger} canUpdateDelete={canUpdateDelete} allFieldStructure={allFieldStructure}
            UpdatePs={updatePsqq} successMessage={successMessage} ApprovalMessage={ApprovalMessage}
            AutomationMessage={AutomationMessage} setErrorData={setErrorData}
            setIsModalVisible1={setIsModalVisible1} setTrigger={setTrigger} />
    ), [memoUrlId, getDetailsDatas, displayData, setNaCTrigger, allFieldStructure, canUpdateDelete, updatePsqq, successMessage, ApprovalMessage, AutomationMessage, setErrorData, setIsModalVisible1, setTrigger, leadStatusData]);
    const MemoLeadFields = useMemo(() => (
        <LeadFields displayData={displayData} setNaCTrigger={setNaCTrigger} arrayDisplayData={arrayDisplayData} />
    ), [arrayDisplayData, setNaCTrigger, displayData]);
    const MemoRelatedTab = useMemo(() => (
        <RelatedTab EntityType="Lead" UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} emailactiontype={emailapiValues} trigger={trigger} />
    ), [memoUrlId, NacTrigger, setNaCTrigger, profile, emailapiValues, trigger]);
    const MemoRightRelatedData = useMemo(() => (
        <LeadRightData displayData={displayData} dataDisables={dataDisables} profile={profile} ViewDetailPage={ViewDetailPage} Role={Role} UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} trigger={trigger} />
    ), [displayData, dataDisables, profile, ViewDetailPage, Role, memoUrlId, NacTrigger, setNaCTrigger, trigger]);
    // ─── sharedProps — all runtime state the special field renderers need ──────
    const leadSharedProps = useMemo(() => ({
        form, edit, combinedUrl, UrlId, displayData,
        users,
        account, dataDisables, setDataDisables, setRelatedLead,
        allCountry, country, handleCountryChange,
        allState, state, handleStateChange,
        allCity, city, handleCityChange,
        images, setImage,
        deleteOptions, setDeleteOption,
        fileLists, setFileList,
    }), [
        form, edit, combinedUrl, UrlId, displayData, users, account, dataDisables,
        allCountry, country, allState, state, allCity, city,
        images, deleteOptions, fileLists,
    ]);
    return (
        <>
            {FromPage === "EntityUpdate" ? (
                <Main>
                    {displayData ? (
                        <>
                            {FromPage === "EntityUpdate" && (
                                <DetailsPage
                                    PageCancel={PageCancel}
                                    handleEditChange={handleEditChange}
                                    canUpdateDelete={canUpdateDelete}
                                    entity="Lead"
                                    UpdatePs={updatePsqq}
                                    moreAction={moreAction}
                                    DetailsPageMoreAction={<MoreAction />}
                                    ButtonActions={ButtonActions}
                                    Maincontent={LeadInfos}
                                    UpdateDataPage={MemoLeadStatusBar}
                                    EntityTabDetails={MemoLeadFields}
                                    EntityRelatedTab={MemoRelatedTab}
                                    RightRelatedDetails={MemoRightRelatedData}
                                />
                            )}
                        </>
                    ) : (
                        <div className="spin"><Spin /></div>
                    )}
                </Main>
            ) : <></>}

            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                title={
                    FromPage === "EntityUpdate" ?
                        drawerPage === "CloneLead" ? "Clone Lead" :
                            <span>
                                Update Lead
                                {(displayData?.firstName || displayData?.lastName) && (
                                    <>
                                        <span style={{ margin: '0 10px', color: '#d9d9d9', fontWeight: 'normal' }}>|</span>
                                        <span style={{ fontWeight: 'normal' }}>
                                            {`${displayData?.firstName || ''} ${displayData?.lastName || ''}`.trim()}
                                        </span>
                                    </>
                                )}
                            </span>
                        : "Create Lead"
                }
                closable={false}
                placement="right"
                open={editField}
                width="80%"
                extra={
                    <Space>
                        {!edit ? (
                            <div className='Hover-Refresh2 back-hover1 able-style' role="button" tabIndex={0} title='Edit'
                                onClick={() => EditOpenForDrawer()}
                                onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') { EditOpenForDrawer(); } }}
                                aria-label='edit'>
                                <EditIcon height={20} width={20} />
                            </div>
                        ) : (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") && (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                                <div role="button" className="Hover-Refresh2 back-hover1 able-style"
                                    tabIndex={0}
                                    onClick={edit ? () => ConnectwithLead(displayData?.primaryEmail) : undefined}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter' || event.key === ' ') {
                                            ConnectwithLead(displayData?.primaryEmail);
                                        }
                                    }}>
                                    <QUSOINIcon height={16} width={16} marginRight={5} />Enrich Lead
                                </div>
                            </div>
                        )}
                        <div className='Hover-Refresh2 back-hover1 able-style' role="button" tabIndex={0} title='Close'
                            onClick={() => PageCancel1()}
                            onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') { PageCancel1(); } }}
                            aria-label='Close'>
                            <CancelIcon width={24} height={24} />
                        </div>
                    </Space>
                }
                footer={(edit && uiReady) ? [
                    <div className="form_action_button">
                        <Button className="gray-button" size="small" onClick={() => PageCancel1()}>
                            <CancelIcon height={25} width={25} />Cancel
                        </Button>
                        {FromPage === "EntityUpdate" && drawerPage !== "CloneLead" ? (
                            <Button
                                disabled={!canUpdateDelete(permissions, dataPermissions, "Delete", 2004) || deleteClick || doubleClick}
                                className="red-button" size="small" loading={deleteClick}
                                onClick={() => deleteMenu(leadId)}>
                                {!deleteClick && <DeleteIcon height={25} width={25} />}Delete
                            </Button>
                        ) : <></>}
                        <Button size="small" htmlType="submit" className="button_colors"
                            onClick={() => form.submit()} loading={doubleClick} disabled={deleteClick || doubleClick}>
                            {!doubleClick && <SaveIcon height={25} width={25} />}
                            {FromPage === "EntityUpdate" && drawerPage !== "CloneLead" ? "Update" : "Save"}
                        </Button>
                    </div>
                ] : false}
            >
                {(displayData && uiReady) ? (
                    <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                        <AddUser>
                            <div className="user-info-form">
                                <Form style={{ width: '100%' }} form={form} name="info" onFinish={handleFinish} onFinishFailed={onFinishFailed} colon={false}>
                                    <BasicFormWrapper>
                                        <VerticalFormStyleWrap>
                                            <div className="add-product-block">
                                                <div style={{ margin: 40 }}>
                                                    <Row gutter={15}>
                                                        <Col xs={24}>
                                                            <div className="add-product-content">
                                                                {/* ✅ ALL groups + attributes driven by API — replaces ~300 lines of static JSX */}
                                                                <CommonFormFields
                                                                    groups={customGroups}
                                                                    customFields={customFields || {}}
                                                                    specialFields={LEAD_SPECIAL_FIELDS}
                                                                    sharedProps={leadSharedProps}
                                                                    optionsMap={optionsMap}
                                                                    combinedUrl={combinedUrl}
                                                                    moduleIcon="LeadIcon"
                                                                    moduleLetter={displayData?.firstName?.slice(0, 1)?.toUpperCase() || 'L'}
                                                                />
                                                                {/* Other Information — not an attribute, stays hardcoded */}
                                                                {(UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD" && drawerPage !== "CloneLead") && <>
                                                                    <Heading as="h5">Other Information</Heading>
                                                                    <Row gutter={[16, 16]} style={{ padding: "15px 15px 20px" }}>
                                                                        <Col xs={24} sm={24} md={24} style={{ marginBottom: 5 }}>
                                                                            <Form.Item label="Created Date" >
                                                                                <span >{displayData?.created_at}</span>
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col xs={24} sm={24} md={24} style={{ marginBottom: 5 }}>
                                                                            <Form.Item label="Created By" >
                                                                                <UploadUserTag record={{
                                                                                    uploadedBy: `${displayData?.createdByFirstName} ${displayData?.createdByLastName}`,
                                                                                    uploadedById: displayData?.created_by,
                                                                                    uploadedProfile: displayData?.createdByProfilePic
                                                                                }} />
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col xs={24} sm={24} md={24} style={{ marginBottom: 5 }}>
                                                                            <Form.Item label="Modified Date" >
                                                                                <span >{displayData?.modified_at}</span>
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col xs={24} sm={24} md={24} style={{ marginBottom: 5 }}>
                                                                            <Form.Item label="Modified By" >
                                                                                <UploadUserTag record={{
                                                                                    uploadedBy: `${displayData?.modifiedByFirstName} ${displayData?.modifiedByLastName}`,
                                                                                    uploadedById: displayData?.modified_by,
                                                                                    uploadedProfile: displayData?.modifiedByProfilePic
                                                                                }} />
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </Row >
                                                                </>
                                                                }
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </VerticalFormStyleWrap>
                                    </BasicFormWrapper>
                                </Form>
                            </div>
                        </AddUser>
                    </Scrollbars>
                ) : (
                    <div className="spin"><Spin /></div>
                )}
            </Drawer>
            <AddTaskPage UrlId={undefined} FromPage={createPageTask} setCratePage={setCreatePageTask} CallBackTrigger={setNaCTrigger} fromPageforTask="FromDetails" taskProp={taskProp} />
            <ComposeMail mailOpen={mailOpen} close={closeMailComposr} entityName="Leads" entity="EntityPages" toId={[{ id: displayData?.leads_id, type: "Leads" }]} CallBackTrigger={setNaCTrigger} />
            {campaignPopup && <AddtoCampaignPopup sharePopup={campaignPopup} setSharePopup={setCampaignPopup} sharingType="Lead" sharingIds={[leadId]} PageTypes="Single" />}
            {outreachPopup && <AddtoOutreachPopup sharePopup={outreachPopup} setSharePopup={setOutreachPopup} sharingType="Lead" sharingIds={leadId} PageTypes="Single" />}
            {sharePopup && <SharePopup sharePopup={sharePopup} setSharePopup={setSharePopup} sharingType="Lead" sharingIds={[leadId]} PageTypes="Single" />}
            {popup && <ConvertPopup popup={popup} setPopup={setPopup} GetAll={getDetailsDatas} popupType={popupType} values={values} action={action} assignOwner={assignOwner} successMessage={successMessage} setDoubleClick={setDelteClick} loadingRef={loadingRef} deleteClick={deleteClick} />}
            {notePopup && <NotesPopup setNotePopup={setNotePopup} notePopup={notePopup} popupType={popupType} UrlId={memoUrlId} setNaCTrigger={setNaCTrigger} page={page} />}
            {callLogPopup && <CallLogPopup setCallLogPopup={setCallLogPopup} callLogPopup={callLogPopup} popupType={popupType} UrlId={memoUrlId} setNaCTrigger={setNaCTrigger} />}
            <MeetingLiPopup meetingOpen={meetingOpen} setMeetingOpen={setMeetingOpen} GetAll={getDetailsDatas} taskPage={taskPage} setNaCTrigger={setNaCTrigger} popupPageType="Create" meetingDate={formattedDate} meetingTime={formattedTime} Attendees={meetingAttendees} />
            <MergePage meetingOpen={mergeOpen} deletecheck={!hasRoleDeletePermission(permissions, 2004)} setMeetingOpen={setMergeOpen} GetAll={getDetailsDatas} pageIdentifier="Leads" setNaCTrigger={setNaCTrigger} PryData={displayData} />
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page="Details" type="Lead" getCallBack={getRefreshtheTable} />}
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
            {popupMessage && <DefaultMessagePopup messagePopup={popupMessage} setMessagePopup={setPopupMessage} pageType={pages} onNavigate={onnavigate} />}
            {approveOpen && <Approvaldialog confirmPopup={approveOpen} setConfirmPopup={setApproveOpen} />}
        </>
    );
}

AddNew.propTypes = {
    UrlId: PropTypes.array.isRequired,
    FromPage: PropTypes.string.isRequired,
    ShortCut: PropTypes.string.isRequired,
    setCratePage: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
};

export default AddNew;